import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function LocationArrow(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M22.172.14C16.752 2.879 6.255 8.08.702 10.83c-1.11.55-.844 2.204.382 2.379l8.459 1.209 1.213 8.489c.175 1.224 1.824 1.492 2.377.386L23.86 1.835C24.405.748 23.256-.407 22.17.14"
  }));
}

export { LocationArrow };
//# sourceMappingURL=LocationArrow.js.map